<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    :return-value.sync="time"
    persistent
    lazy
    full-width
    width="290px"
  >
    <template v-slot:activator="{ on }">
      <form-input :name="name" @focus="modal = true"></form-input>
    </template>
    <v-time-picker v-if="modal" format="24hr" v-model="fields[name].value" full-width>
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="modal = false">Отмена</v-btn>
      <v-btn flat color="primary" @click="$refs.dialog.save(time)">OK</v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'
  import FormInput from '@/components/create-form/Input'

  const {mapMutations, mapState} = createNamespacedHelpers('mainPage')
  export default {
    name: 'TimePicker',
    data () {
      return {
        time: '',
        modal: false,

      }
    },
    props: ['name', 'min'],
    computed: {
      ...mapState([
        'fields'
      ]),
    },
    methods: {
      ...mapMutations([
        'setField'
      ]),
      hide () {
        this.$emit('close')
      },
    },
    components: {
      FormInput
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/create-form/TimePicker.vue